











import vue from "vue";
import {
  VUEX_EXERCISE_ACTION_NAMES,
  VUEX_EXERCISE_GETTER_NAMES,
  VUEX_EXERCISE_NAMESPACE,
  VUEX_ROOT_GETTER_NAMES
} from "@tt-app/constants";
import { FlatExerciseListDetails, nextExerciseRouter } from "@tt-app/utils";

import BaseExerciseFooter from "@tt-app/components/exercise/consolidated/exercise/footer/BaseExerciseFooter.vue";
import WritingReviewFooter from "@tt-app/components/exercise/consolidated/exercise/footer/WritingReviewFooter.vue";

const { ATTEMPT_EXERCISE_CLOSE } = VUEX_EXERCISE_ACTION_NAMES;
const { FLAT_EXERCISE_LIST } = VUEX_ROOT_GETTER_NAMES;
const { EXERCISE_TYPE } = VUEX_EXERCISE_GETTER_NAMES;

interface Methods {
  handleEndExercise: () => void;
  handleNextExercise: () => void;
}

interface Computed {
  assignmentId: string;
  courseUuid: string;
  currentExerciseListIndex: number;
  exerciseType: number;
  exerciseUuid: string;
  flatExerciseList: FlatExerciseListDetails[];
  footerComponent: any;
  nextExercise: FlatExerciseListDetails;
}

export default vue.extend<any, Methods, Computed, any>({
  name: "ReviewFooter",

  components: {
    BaseExerciseFooter,
    WritingReviewFooter
  },

  methods: {
    handleEndExercise() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${ATTEMPT_EXERCISE_CLOSE}`);
    },

    handleNextExercise() {
      nextExerciseRouter({
        assignmentId: this.assignmentId,
        courseUuid: this.courseUuid,
        ...this.nextExercise
      });
    }
  },

  computed: {
    assignmentId() {
      return this.$route.params.assignmentId;
    },

    courseUuid() {
      return this.$route.params.courseUuid;
    },

    currentExerciseListIndex() {
      const listIndex = this.flatExerciseList.findIndex(
        (exerciseDetails: FlatExerciseListDetails) => {
          return exerciseDetails.uuid === this.exerciseUuid;
        }
      );

      return listIndex >= 0 ? listIndex : null;
    },

    exerciseType() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_TYPE}`];
    },

    exerciseUuid() {
      return this.$route.params.exerciseUuid;
    },

    flatExerciseList() {
      return this.$store.getters[FLAT_EXERCISE_LIST]({
        assignmentId: this.assignmentId,
        courseUuid: this.courseUuid
      });
    },

    footerComponent() {
      switch (this.exerciseType) {
        case 13:
          return "writing-review-footer";
        default:
          return "";
      }
    },

    nextExercise() {
      if (this.currentExerciseListIndex === null) return undefined;
      return this.flatExerciseList[this.currentExerciseListIndex + 1];
    }
  }
});
